import { useEffect } from 'react';
import { X } from 'lucide-react';
import { DEMO_DATA_NOTE_EN, DEMO_DATA_NOTE_NL } from './constants';

export const demoNoteFor = (lang) => (lang === 'nl' ? DEMO_DATA_NOTE_NL : DEMO_DATA_NOTE_EN);

// Screenshot lightbox. Every product shot on the marketing site is
// clickable and opens full-size so the detail is actually readable; the
// zoomed view always carries the "Demo data shown" stamp, because every
// screenshot comes from the fictional demo tenant, never a customer.
export const ScreenshotLightbox = ({ shot, caption, note, onClose }) => {
  useEffect(() => {
    if (!shot) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [shot, onClose]);

  if (!shot) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 sm:p-8"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={caption}
      data-testid="screenshot-lightbox"
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 sm:top-6 sm:right-6 h-10 w-10 rounded-full border border-white/20 bg-white/5 text-white/80 hover:bg-white/15 hover:text-white transition-colors flex items-center justify-center cursor-pointer"
        aria-label="Close"
        data-testid="screenshot-lightbox-close"
      >
        <X className="h-5 w-5" />
      </button>

      <figure className="m-0 relative max-h-full w-full max-w-6xl" onClick={(e) => e.stopPropagation()}>
        <div className="relative">
          <img
            src={shot}
            alt={caption}
            className="w-full max-h-[80vh] object-contain rounded-xl border border-white/15 shadow-2xl bg-[#0a0a0a]"
            data-testid="screenshot-lightbox-image"
          />
          <span
            className="absolute right-3 bottom-3 px-2.5 py-1 rounded-md bg-black/80 border border-white/25 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/90 shadow-lg"
            data-testid="screenshot-lightbox-demo-note"
          >
            {note}
          </span>
        </div>
        <figcaption className="mt-3 text-center text-xs text-white/55" data-testid="screenshot-lightbox-caption">
          {caption} · {note}
        </figcaption>
      </figure>
    </div>
  );
};
